// NotificationForm.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import BASE_URL from "../config";
import "bootstrap/dist/css/bootstrap.min.css";
// your APIs
const COURSES_API  = `${BASE_URL}/api/course`;
const CLASSES_API  = `${BASE_URL}/api/classes`;
const SENDMSG_API  = `${BASE_URL}/api/sendmsg`;
// Templates
const TEMPLATES = {
  holiday: {
    name: "Holiday Notice",
    content: `Dear Parents,\nPlease note that the school will remain closed on {#var#} on account of {#var#}.\nRegular classes will resume on {#var#}.\nWishing you a happy and safe holiday.\nFrom, Shri Vidyaspoorti School -SCHAMY&template_id=1707174903564811553`,
    placeholders: ["Date", "Occasion", "Date"] // 3 vars
  },
  exam: {
    name: "Exam Notification",
    content: `Dear Parents,\nThis is to inform you that the {#var#} for {#var#} will commence from {#var#}.\nKindly ensure that your SON/DOUGHTER is well-prepared and present on all exam days.\nThe detailed timetable has been shared with the students.\nFrom, Shri Vidyaspoorti School -SCHAMY&template_id=1707174971027093455`,
    placeholders: ["Test/Exam Name", "Class Name", "Date"] // 3 vars
  },
  event: {
    name: "Event Invitation",
    content: `Dear Parent/Guardian,\nWe are pleased to inform you that {#var#} will be organizing {#var#} on {#var#} at {#var#} in the {#var#}.\nYour presence and encouragement will mean a lot to our students.\nWe look forward to seeing you there!\nFrom,Shri Vidyaspoorti School -SCHAMY&template_id=1707175074039341836`,
     placeholders: ["SchoolName", "Event", "Date", "Time", "Venue"] // 5 vars
  }
};
export default function NotificationForm() {
  const [courses, setCourses]           = useState([]);
  const [classes, setClasses]           = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedClass, setSelectedClass]   = useState("");
  //const [message, setMessage]           = useState("");
  const [status, setStatus]             = useState("");
const [templateKey, setTemplateKey] = useState("");
  const [templateInputs, setTemplateInputs] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [sections, setSections] = useState([]);
const [selectedSection, setSelectedSection] = useState("");
  // 1️⃣ load courses once
  useEffect(() => {
    axios.get(COURSES_API)
      .then(res => setCourses(res.data))
      .catch(err => console.error("Error loading courses", err));
  }, []);

  // 2️⃣ when course changes, load classes
  useEffect(() => {
    if (!selectedCourse) {
      setClasses([]);
      setSelectedClass("");
      setSelectedYear("");
      return;
    }
    fetchAcademicYears(selectedCourse);
    axios.get(`${CLASSES_API}?course=${selectedCourse}`)
      .then(res => setClasses(res.data))
      .catch(err => console.error("Error loading classes", err));
  }, [selectedCourse]);
// When a template is selected
  useEffect(() => {
    if (templateKey && TEMPLATES[templateKey]) {
      //const count = (TEMPLATES[templateKey].content.match(/{#var#}/g) || []).length;
       const { placeholders } = TEMPLATES[templateKey];
    setTemplateInputs(placeholders.map(() => ""));
      //setTemplateInputs(Array(count).fill(""));
    } else {
      setTemplateInputs([]);
    }
  }, [templateKey]);


useEffect(() => {
  if (!selectedClass) {
    setSections([]);
    setSelectedSection("");
    return;
  }

  // Fetch sections for the selected class
  axios.get(`${BASE_URL}/api/sections/${selectedClass}`)
    .then(res => {
      if (res.data.length > 0) {
        setSections(res.data);
      } else {
        setSections([]);
        setSelectedSection("");
      }
    })
    .catch(err => {
      console.error("Error fetching sections:", err);
    });
}, [selectedClass]);


 const fetchAcademicYears = async (courseID) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/academicYears/${courseID}`);
      setAcademicYears(res.data);
    } catch (error) {
      console.error("Error fetching academic years:", error);
    }
  };
  const handleInputChange = (i, value) => {
    if (value.length > 30) return;
    const copy = [...templateInputs];
    copy[i] = value;
    setTemplateInputs(copy);
  };
  const renderMessagePreview = () => {
    if (!templateKey || !TEMPLATES[templateKey]) return "";
    const parts = TEMPLATES[templateKey].content.split("{#var#}");
    return (
      <div className="border rounded p-3 bg-light" style={{ whiteSpace: "pre-wrap" }}>
        {parts.map((part, i) => (
          <span key={i}>
            {part}
            {i < templateInputs.length && (
              <input
                type="text"
                value={templateInputs[i]}
                 placeholder={TEMPLATES[templateKey].placeholders[i]}
                onChange={e => handleInputChange(i, e.target.value)}
                maxLength={30}
                className="form-control-plaintext mx-1 my-1"
                style={{ width: "30ch", display: "inline-block",border: "none",
    borderBottom: "1px dashed #ccc", // optional underline
    backgroundColor: "transparent",
    fontFamily: "inherit",
    fontSize: "inherit",
    padding: 0,
    margin: "0 2px" }}
              />
            )}
          </span>
        ))}
      </div>
    );
  };
  // 3️⃣ when form submits, fire the bulk‐send endpoint
  const handleSubmit = (e) => {
    e.preventDefault();
    const compiledMessage = TEMPLATES[templateKey].content.replace(/{#var#}/g, () => templateInputs.shift());
    setStatus("Sending notifications…");

    axios.get(SENDMSG_API, {
      params: {
        course:  selectedCourse,
        class:   selectedClass,
        year:selectedYear,
         section: selectedSection || "", // pass empty if not selected
        unicode:0,
        message: compiledMessage
      }
    })
    .then(res => {
      const { sentTo, mobiles } = res.data;
      setStatus(`✓ Sent to ${sentTo} students${ sentTo ? ` (${mobiles.join(", ")})` : "" }`);
      //setMessage("");
      setTemplateInputs([]);
      setTemplateKey("");
    })
    .catch(err => {
      console.error("Bulk send failed", err);
      setStatus("❌ Failed to send notifications");
    });
  };

  return (
    <div className="container mt-5" style={{ maxWidth: 700 }}>
      <h2 className="mb-4 text-center">Send Notification</h2>
      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          {/* Course dropdown */}
          <div className="col-md-6">
            <label className="form-label">Course</label>
            <select
              className="form-select"
              value={selectedCourse}
              onChange={e => setSelectedCourse(e.target.value)}
              required
            >
              <option value="">Select Course</option>
              {courses.map(c => (
                <option key={c.CourseID} value={c.CourseID}>
                  {c.CourseName}
                </option>
              ))}
            </select>
          </div>
          {/* Academic Year dropdown */}
          <div className="col-md-6">
             <label className="form-label">Academic Year</label>
              <select
              className="form-select"
              value={selectedYear}
              onChange={e => setSelectedYear(e.target.value)}
              required
            >
              <option value="">Select Academic Year</option>
              {academicYears.map(c => (
                <option key={c.AcademicYearID} value={c.AcademicYearID}>
                  {c.AcademicYearName}
                </option>
              ))}
            </select>
                          {/* value={selectedYear || ""}
                          onChange={(e) => setSelectedYear(e.target.value)}
                          disabled={!selectedCourse || academicYears.length === 0}
                        >
                          <MenuItem value="">-- Select Academic Year --</MenuItem>
                          {academicYears.length > 0 ? (
                            academicYears.map((year) => (
                              <MenuItem key={year.AcademicYearID} value={year.AcademicYearID}>
                                {year.AcademicYearName}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem value="" disabled>No academic years available</MenuItem>
                          )}
                        </TextField>
                      </Grid> */}
          </div>
          {/* Class dropdown */}
          <div className="col-md-6">
            <label className="form-label">Class</label>
            <select
              className="form-select"
              value={selectedClass}
              onChange={e => setSelectedClass(e.target.value)}
              required
              disabled={!classes.length}
            >
              <option value="">Select Class</option>
              {classes.map(cl => (
                <option key={cl.id} value={cl.id}>
                  {cl.ClassName || cl.name}
                </option>
              ))}
            </select>
          </div>
{sections.length > 0 && (
  <div className="col-md-6">
    <label className="form-label">Section</label>
    <select
      className="form-select"
      value={selectedSection}
      onChange={e => setSelectedSection(e.target.value)}
    >
      <option value="">Select Section</option>
      {sections.map(sec => (
        <option key={sec.SectionID} value={sec.SectionID}>
          {sec.SectionName}
        </option>
      ))}
    </select>
  </div>
)}



          {/* Message field */}
          {/* <div className="col-12">
            <label className="form-label">Message</label>
            <textarea
              className="form-control"
              rows={4}
              value={message}
              onChange={e => setMessage(e.target.value)}
              placeholder="Type your notification here…"
              required
            />
          </div> */}
           <div className="col-md-12">
            <label className="form-label">Select Message Template</label>
            <select
              className="form-select"
              value={templateKey}
              onChange={e => setTemplateKey(e.target.value)}
              required
            >
              <option value="">Select Template</option>
              {Object.entries(TEMPLATES).map(([key, val]) => (
                <option key={key} value={key}>{val.name}</option>
              ))}
            </select>
          </div>
          <div className="col-12">
            <label className="form-label">Message Preview</label>
            {renderMessagePreview()}
          </div>
        </div>
        {/* Send button */}
        <div className="text-center mt-4">
          <button
            type="submit"
            className="btn btn-primary px-4 py-2 rounded-pill"
            disabled={!selectedCourse || !selectedYear || !selectedClass || !templateKey || templateInputs.includes("")}
          >
            Send Notifications
          </button>
        </div>
        {/* Status */}
        {status && (
          <div className="alert alert-info mt-3" style={{ whiteSpace: "pre-wrap" }}>
            {status}
          </div>
        )}
      </form>
    </div>
  );
}
